import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from 'features/core/shared/object/mvs-object-base/object-base.component';
import {NavigationItem} from 'features/core/shared/dto/navigation/navigation-item';

/**
* Object component for cn.CommissionRule (FR-3 / FR-4).
*
* CommissionRule is a Complex Configuration Entity (Tier + Condition + Hook children),
* so it is edited here on its dedicated Object-Page — never inline (CONFIG-003).
*
* This is the ObjectBaseComponent wrapper that loads the dto and delegates rendering to the
* uiMode-specific view (full / side). The views own the left-nav sections:
*   Allgemein / Staffeln / Bedingungen / Cap / LogicHook / Haftung-Kaution / Vorschau.
*
* G2.4/G2.5: onObjectChanged() is implemented and never calls refreshObject().
*/
@Component({
    selector: 'mvs-cn-commission-rule-object-component',
    templateUrl: './cn-commission-rule-object.component.html',
    styleUrls: ['./cn-commission-rule-object.component.scss'],
    standalone: false
})
export class CnCommissionRuleObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    navigationItems: NavigationItem[];
    activeNavigationItem: NavigationItem;

    /**
    * On Object Change. Hook for post-load logic; intentionally empty here because
    * the views build their widgets from the objectIdentifier (no refreshObject()).
    */
    onObjectChanged() {
    }

    getNavigationItems(): NavigationItem[] {
        return this.navigationItems;
    }

    /**
    * Receive the navigation items built by the active uiMode view (full / side) and
    * re-emit them to the hosting object page so the left-nav can render (G5.2 / G6.2).
    */
    handleNavigationItems(items: NavigationItem[]): void {
        this.navigationItems = items;
        this.onNavigationItems.emit(this.navigationItems);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
        if (changes['objectIdentifier']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
